import { GiChocolateBar } from "react-icons/gi";
import { AiTwotoneBank } from "react-icons/ai";
import { MdOutlineCastForEducation } from "react-icons/md";
import { BsGlobe2 } from "react-icons/bs";

import "./Features.scss";

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="row">
        <div className="col-1-of-4">
          <div className="feature-box">
            <i className="feature-box-icon">
              <BsGlobe2 />
            </i>
            <h3 className="heading-tertiary u-margin-bottom-small">
              intersting places
            </h3>
            <p className="feature-box-text">
              St. Moritz: Renowned as a luxury alpine resort, St. Moritz offers
              world-class skiing, upscale shopping, and a lively social scene.
              Enjoy winter sports, relax in luxury spas, and soak up the
              glamorous atmosphere of this chic mountain destination.
            </p>
          </div>
        </div>
        <div className="col-1-of-4">
          <div className="feature-box">
            <i className="feature-box-icon">
              <GiChocolateBar />
            </i>
            <h3 className="heading-tertiary u-margin-bottom-small">
              Most known treat
            </h3>
            <p className="feature-box-text">
              Swiss Chocolate: Switzerland is synonymous with delicious
              chocolate. Swiss chocolatiers are renowned for their craftsmanship
              and use of high-quality ingredients. Brands like Lindt, Toblerone,
              and Nestlé originated in Switzerland.
            </p>
          </div>
        </div>
        <div className="col-1-of-4">
          <div className="feature-box">
            <i className="feature-box-icon">
              <AiTwotoneBank />
            </i>
            <h3 className="heading-tertiary u-margin-bottom-small">
              one of many strengths
            </h3>
            <p className="feature-box-text">
              Direct Democracy: Switzerland is known for its system of direct
              democracy. Swiss citizens can influence legislation through
              referendums and initiatives. They have the power to propose
              changes to the constitution and vote on various issues.
            </p>
          </div>
        </div>
        <div className="col-1-of-4">
          <div className="feature-box">
            <i className="feature-box-icon">
              <MdOutlineCastForEducation />
            </i>
            <h3 className="heading-tertiary u-margin-bottom-small">
              education
            </h3>
            <p className="feature-box-text">
              Switzerland has a highly regarded education system . It is home to
              several world-renowned universities, including ETH Zurich (Swiss
              Federal Institute of Technology) and the University of Geneva.
              Many Nobel laureates have been associated with Swiss institutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Features;
